import { render, staticRenderFns } from "./ReopenShiftForm.vue?vue&type=template&id=545f1760"
import script from "./ReopenShiftForm.vue?vue&type=script&lang=js"
export * from "./ReopenShiftForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports